const RELOADED_KEY = 'vite-preload-error-reloaded'

/**
 * Every deploy replaces the hashed asset files, so a tab opened before one 404s
 * on the next chunk it imports and lands on the error boundary. Reloading picks
 * up the current build. The flag caps this at one reload per tab, so a chunk
 * that is missing for any other reason cannot loop.
 *
 * Only failures of our own hashed assets count. Bundled third-party SDKs make
 * dynamic imports of their own (RudderStack pulls its plugins from
 * cdn.rudderlabs.com through the same Vite helper), and content blockers fail
 * those on every load — reloading then would flash the page for anyone running
 * an adblocker without fixing anything.
 */
export const reloadStaleBundle = (event: Event) => {
  const message =
    (event as { payload?: { message?: string } }).payload?.message ?? ''
  const failedUrl = message.match(/https?:\/\/\S+/)?.[0]
  if (!failedUrl || new URL(failedUrl).origin !== window.location.origin) return

  try {
    if (sessionStorage.getItem(RELOADED_KEY)) return
    sessionStorage.setItem(RELOADED_KEY, '1')
  } catch {
    return // storage is blocked, so the reload cannot be capped
  }
  window.location.reload()
}
